import { create } from 'zustand'

interface LoadingState {
  progress: number
  isLoaded: boolean
  isVisible: boolean
  setProgress: (progress: number) => void
  setLoaded: () => void
  hideLoader: () => void
}

export const useLoadingStore = create<LoadingState>((set) => ({
  progress: 0,
  isLoaded: false,
  isVisible: true,
  setProgress: (progress) => set({ progress: Math.min(100, Math.max(0, progress)) }),
  setLoaded: () => set({ isLoaded: true, progress: 100 }),
  hideLoader: () => set({ isVisible: false }),
}))
